'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Clone = require('@hapi/hoek/lib/clone');
var Reach = require('@hapi/hoek/lib/reach');
var Common = require('./common');
var Template;
var internals = {
  symbol: Symbol('ref'),
  // Used to internally identify references (shared with other joi versions)
  defaults: {
    adjust: null,
    in: false,
    iterables: null,
    map: null,
    separator: '.',
    type: 'value'
  }
};
exports.create = function (key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Assert(typeof key === 'string', 'Invalid reference key:', key);
  Common.assertOptions(options, ['adjust', 'ancestor', 'in', 'iterables', 'map', 'prefix', 'separator']);
  Assert(!options.prefix || typeof options.prefix === 'object', 'options.prefix must be of type object');
  var ref = Object.assign({}, internals.defaults, options);
  delete ref.prefix;
  var separator = ref.separator;
  var context = internals.context(key, separator, options.prefix);
  ref.type = context.type;
  key = context.key;
  if (ref.type === 'value') {
    if (context.root) {
      Assert(!separator || key[0] !== separator, 'Cannot specify relative path with root prefix');
      ref.ancestor = 'root';
      if (!key) {
        key = null;
      }
    }
    if (separator && separator === key) {
      key = null;
      ref.ancestor = 0;
    } else {
      if (ref.ancestor !== undefined) {
        Assert(!separator || !key || key[0] !== separator, 'Cannot combine prefix with ancestor option');
      } else {
        var _internals$ancestor = internals.ancestor(key, separator),
          _internals$ancestor2 = _slicedToArray(_internals$ancestor, 2),
          ancestor = _internals$ancestor2[0],
          slice = _internals$ancestor2[1];
        if (slice) {
          key = key.slice(slice);
          if (key === '') {
            key = null;
          }
        }
        ref.ancestor = ancestor;
      }
    }
  }
  ref.path = separator ? key === null ? [] : key.split(separator) : [key];
  return new internals.Ref(ref);
};
exports.in = function (key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return exports.create(key, Object.assign({}, options, {
    in: true
  }));
};
exports.isRef = function (ref) {
  return ref ? !!ref[Common.symbols.ref] : false;
};
internals.Ref = /*#__PURE__*/function () {
  function _class(options) {
    _classCallCheck(this, _class);
    Assert(typeof options === 'object', 'Invalid reference construction');
    Common.assertOptions(options, ['adjust', 'ancestor', 'in', 'iterables', 'map', 'path', 'separator', 'type',
    // Copied
    'depth', 'key', 'root', 'display' // Overridden
    ]);
    Assert([false, undefined].includes(options.separator) || typeof options.separator === 'string' && options.separator.length === 1, 'Invalid separator');
    Assert(!options.adjust || typeof options.adjust === 'function', 'options.adjust must be a function');
    Assert(!options.map || Array.isArray(options.map), 'options.map must be an array');
    Assert(!options.map || !options.adjust, 'Cannot set both map and adjust options');
    Object.assign(this, internals.defaults, options);
    Assert(this.type === 'value' || this.ancestor === undefined, 'Non-value references cannot reference ancestors');
    if (Array.isArray(this.map)) {
      this.map = new Map(this.map);
    }
    this.depth = this.path.length;
    this.key = this.path.length ? this.path.join(this.separator) : null;
    this.root = this.path[0];
    this.updateDisplay();
  }
  _createClass(_class, [{
    key: "resolve",
    value: function resolve(value, state, prefs, local) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      Assert(!this.in || options.in, 'Invalid in() reference usage');
      if (this.type === 'global') {
        return this._resolve(prefs.context, state, options);
      }
      if (this.type === 'local') {
        return this._resolve(local, state, options);
      }
      if (!this.ancestor) {
        return this._resolve(value, state, options);
      }
      if (this.ancestor === 'root') {
        return this._resolve(state.ancestors[state.ancestors.length - 1], state, options);
      }
      Assert(this.ancestor <= state.ancestors.length, 'Invalid reference exceeds the schema root:', this.display);
      return this._resolve(state.ancestors[this.ancestor - 1], state, options);
    }
  }, {
    key: "_resolve",
    value: function _resolve(target, state, options) {
      var resolved;
      if (this.type === 'value' && state.mainstay.shadow && options.shadow !== false) {
        resolved = state.mainstay.shadow.get(this.absolute(state));
      }
      if (resolved === undefined) {
        resolved = Reach(target, this.path, {
          iterables: this.iterables,
          functions: true
        });
      }
      if (this.adjust) {
        resolved = this.adjust(resolved);
      }
      if (this.map) {
        var mapped = this.map.get(resolved);
        if (mapped !== undefined) {
          resolved = mapped;
        }
      }
      if (state.mainstay) {
        state.mainstay.tracer.resolve(state, this, resolved);
      }
      return resolved;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.display;
    }
  }, {
    key: "absolute",
    value: function absolute(state) {
      return [].concat(_toConsumableArray(state.path.slice(0, -this.ancestor)), _toConsumableArray(this.path));
    }
  }, {
    key: "clone",
    value: function clone() {
      return new internals.Ref(this);
    }
  }, {
    key: "describe",
    value: function describe() {
      var ref = {
        path: this.path
      };
      if (this.type !== 'value') {
        ref.type = this.type;
      }
      if (this.separator !== '.') {
        ref.separator = this.separator;
      }
      if (this.type === 'value' && this.ancestor !== 1) {
        ref.ancestor = this.ancestor;
      }
      if (this.map) {
        ref.map = _toConsumableArray(this.map);
      }
      for (var _i = 0, _arr = ['adjust', 'iterables']; _i < _arr.length; _i++) {
        var key = _arr[_i];
        if (this[key] !== null) {
          ref[key] = this[key];
        }
      }
      if (this.in !== false) {
        ref.in = true;
      }
      return {
        ref: ref
      };
    }
  }, {
    key: "updateDisplay",
    value: function updateDisplay() {
      var key = this.key !== null ? this.key : '';
      if (this.type !== 'value') {
        this.display = "ref:".concat(this.type, ":").concat(key);
        return;
      }
      if (!this.separator) {
        this.display = "ref:".concat(key);
        return;
      }
      if (!this.ancestor) {
        this.display = "ref:".concat(this.separator).concat(key);
        return;
      }
      if (this.ancestor === 'root') {
        this.display = "ref:root:".concat(key);
        return;
      }
      if (this.ancestor === 1) {
        this.display = "ref:".concat(key || '..');
        return;
      }
      var lead = new Array(this.ancestor + 1).fill(this.separator).join('');
      this.display = "ref:".concat(lead).concat(key || '');
    }
  }]);
  return _class;
}();
internals.Ref.prototype[Common.symbols.ref] = true;
exports.build = function (desc) {
  desc = Object.assign({}, internals.defaults, desc);
  if (desc.type === 'value' && desc.ancestor === undefined) {
    desc.ancestor = 1;
  }
  return new internals.Ref(desc);
};
internals.context = function (key, separator) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  key = key.trim();
  if (prefix) {
    var globalp = prefix.global === undefined ? '$' : prefix.global;
    if (globalp !== separator && key.startsWith(globalp)) {
      return {
        key: key.slice(globalp.length),
        type: 'global'
      };
    }
    var local = prefix.local === undefined ? '#' : prefix.local;
    if (local !== separator && key.startsWith(local)) {
      return {
        key: key.slice(local.length),
        type: 'local'
      };
    }
    var root = prefix.root === undefined ? '/' : prefix.root;
    if (root !== separator && key.startsWith(root)) {
      return {
        key: key.slice(root.length),
        type: 'value',
        root: true
      };
    }
  }
  return {
    key: key,
    type: 'value'
  };
};
internals.ancestor = function (key, separator) {
  if (!separator) {
    return [1, 0]; // 'a_b' -> 1 (parent)
  }
  if (key[0] !== separator) {
    // 'a.b' -> 1 (parent)
    return [1, 0];
  }
  if (key[1] !== separator) {
    // '.a.b' -> 0 (self)
    return [0, 1];
  }
  var i = 2;
  while (key[i] === separator) {
    ++i;
  }
  return [i - 1, i]; // '...a.b.' -> 2 (grandparent)
};
exports.toSibling = 0;
exports.toParent = 1;
exports.Manager = /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
    this.refs = []; // 0: [self refs], 1: [parent refs], 2: [grandparent refs], ...
  }
  _createClass(_class2, [{
    key: "register",
    value: function register(source, target) {
      if (!source) {
        return;
      }
      target = target === undefined ? exports.toParent : target;

      // Array

      if (Array.isArray(source)) {
        var _iterator = _createForOfIteratorHelper(source),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ref = _step.value;
            this.register(ref, target);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return;
      }

      // Schema

      if (Common.isSchema(source)) {
        var _iterator2 = _createForOfIteratorHelper(source._refs.refs),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            if (item.ancestor - target >= 0) {
              this.refs.push({
                ancestor: item.ancestor - target,
                root: item.root
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return;
      }

      // Reference

      if (exports.isRef(source) && source.type === 'value' && source.ancestor - target >= 0) {
        this.refs.push({
          ancestor: source.ancestor - target,
          root: source.root
        });
      }

      // Template

      Template = Template || require('./template');
      if (Template.isTemplate(source)) {
        this.register(source.refs(), target);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      var copy = new exports.Manager();
      copy.refs = Clone(this.refs);
      return copy;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.refs = [];
    }
  }, {
    key: "roots",
    value: function roots() {
      return this.refs.filter(function (ref) {
        return !ref.ancestor;
      }).map(function (ref) {
        return ref.root;
      });
    }
  }, {
    key: "length",
    get: function get() {
      return this.refs.length;
    }
  }]);
  return _class2;
}();